import { Routes } from '@angular/router';
import { AuthGuard } from './../guards/auth.guard';

export const routes: Routes = [
  {
    path: 'vermittlers' as const,
    loadComponent: () =>
      import('./page-vermittlers/vermittlers-page.component').then(
        (c) => c.VermittlersPageComponent
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './page-vermittlers/vermittlers-list/vermittlers-list.component'
          ).then((c) => c.VermittlersListComponent),
      },
      {
        path: 'add',
        loadComponent: () =>
          import(
            './page-vermittlers/vermittler-add/vermittler-add.component'
          ).then((c) => c.VermittlerAddComponent),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import(
            './page-vermittlers/vermittler-edit/vermittler-edit.component'
          ).then((c) => c.VermittlerEditComponent),
      },
      {
        path: ':id',
        loadComponent: () =>
          import(
            './page-vermittlers/vermittler-details/vermittler-details.component'
          ).then((c) => c.VermittlerDetailsComponent),
      },
    ],
  },
  {
    path: 'vermittlergruppen' as const,
    loadComponent: () =>
      import('./page-vermittlergruppe/vermittlergruppe-page.component').then(
        (c) => c.VermittlergruppePageComponent
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './page-vermittlergruppe/vermittlergruppe-list/vermittlergruppe-list.component'
          ).then((c) => c.VermittlergruppeListComponent),
      },
        {
      path: ':id',
      loadComponent: () =>
        import(
          './page-vermittlergruppe/vermittlergruppe-details/vermittlergruppe-details.component'
        ).then((c) => c.VermittlergruppeDetailsComponent),
    },
    ],
  },

  {
    path: 'users' as const,
    loadComponent: () =>
      import('./page-users/users-page.component').then(
        (c) => c.UsersPageComponent
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./page-users/users-list/users-list.component').then(
            (c) => c.UsersListComponent
          ),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./page-users/user-add/user-add.component').then(
            (c) => c.UserAddComponent
          ),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./page-users/user-edit/user-edit.component').then(
            (c) => c.UserEditComponent
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./page-users/user-details/user-details.component').then(
            (c) => c.UserDetailsComponent
          ),
      },
    ],
  },

  {
    path: 'dashboard',
    loadComponent: () =>
      import('./page-dashboard/dashboard-page.component').then(
        (c) => c.DashboardPageComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./page-notifications/notifications-page.component').then(
        (c) => c.NotificationsPageComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./page-forbidden/page-forbidden.component').then(
        (c) => c.PageForbiddenComponent
      ),
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard' },
];
